export default __webpack_public_path__ + "static/media/221.e958155c.svg";